import { Formik, FormikHelpers } from "formik";
import { withFormikDevtools } from "formik-devtools-extension";

import AccountLookup, { AccountLookupFormValues } from "./AccountLookup";
import accountLookupSchema from "./accountLookupValidation";

interface AccountLookupProps {
  setAccountId: (accountId: string) => void;
  accountId: string;
}

const AccountLookupWrapper = ({
  setAccountId,
  accountId,
}: AccountLookupProps) => {
  const handleSubmit = (
    values: AccountLookupFormValues,
    formikHelpers: FormikHelpers<AccountLookupFormValues>
  ) => {
    setAccountId(values.accountId);
    formikHelpers.setSubmitting(false);
  };

  const formikConfig = {
    onSubmit: handleSubmit,
    initialValues: accountLookupSchema.cast({}) as AccountLookupFormValues,
    validationSchema: accountLookupSchema,
    validateOnMount: true,
  };

  return (
    <Formik {...formikConfig}>
      {formikProps => {
        withFormikDevtools(formikProps);
        return <AccountLookup lookupAccountId={accountId} />;
      }}
    </Formik>
  );
};

export default AccountLookupWrapper;
